
import ValidateField from '../hooks/useValid';
import { ValidateName } from '../constants/ValidateNameConstants';

export function validationContact(values, contact) {
    const errors = {};
  
    errors.name = ValidateField(
      values.name,
      ValidateName?.CONTACT_NAME,
      ValidateName?.CONTACT_NAME,
      [ValidateName?.REQUIRED, ValidateName?.ISTEXTONLY],
    );
  
    errors.phone = ValidateField(
      values.phone,
      ValidateName?.PHONE_NUMBER,
      ValidateName?.PHONE_NUMBER,
      [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE],
    );
  
    errors.email = ValidateField(
      values.email,
      ValidateName?.EMAIL,
      ValidateName?.EMAIL,
      [ValidateName?.REQUIRED, ValidateName?.ISVALID_EMAIL],
    );
  
    errors.department = ValidateField(
      values.departmentId,
      ValidateName?.DEPARTMENT,
      ValidateName?.DEPARTMENT,
      [ValidateName?.REQUIRED],
    );
    errors.designation = ValidateField(
      values.designationId,
      ValidateName?.DESINATION,
      ValidateName?.DESINATION,
      [ValidateName?.REQUIRED],
    );
  
    errors.contact = ValidateField(
      values,
      ValidateName?.CONTACT_AVAILABLE,
      ValidateName?.CONTACT_AVAILABLE,
      [ValidateName?.UNIQUE_CONTACTS], undefined, contact
    );
  
    let error = {}
    Object.keys(errors).map((key, index) => {
      if (errors[key] !== undefined)
      error[key] = errors[key]
    })
  
    return error
  }